import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

const t = {
  and: 'and',
};

class WeekDays extends PureComponent {
  render() {
    const { isoDays } = this.props;

    return isoDays.sort().map((isoDay, index) => (
      <Fragment key={index}>
        {isoDays.length >= 3 ? moment.weekdaysShort(isoDay) : moment.weekdays(isoDay)}
        {index !== isoDays.length - 1 ? (index === isoDays.length - 2 ? ` ${t.and} ` : ', ') : null}
      </Fragment>
    ));
  }
}

WeekDays.propTypes = {
  isoDays: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
};

export default WeekDays;
